import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-page-wrapper',
  templateUrl: './page-wrapper.component.html',
  styleUrls: ['./page-wrapper.component.less']
})
export class PageWrapperComponent implements OnInit {
  // classList: string = '';
  @Input() className: string = '';
  @Input() contentClass: string = '';
  @Input() id: string = '';
  @ViewChild('innerWrapper') innerWrapper!: ElementRef<HTMLDivElement>;
  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    this.resize()
  }
  constructor() {

  }

  resize() {
    const width = (this.innerWrapper.nativeElement.offsetWidth / 100) + 'px';
    document.body.style.fontSize = width;
    // console.timeLog('resize',  width);
  }

  ngOnInit() {
    setTimeout(() => { this.resize(); }, 100);
  }

}
